import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserProductViews } from "../../actions";
import { generatePublicUrl } from "../../urlConfig";
import Loader from "../../components/Loader";
import EmptyMessage from "./EmptyMessage";

const UserHistoryItems = ({ userId, loading, message }) => {
    const { productsHistory, totalNumberProduct } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const history = Array.isArray(productsHistory) ? productsHistory : [];

    useEffect(() => {
        dispatch(getUserProductViews(userId));
    }, [dispatch, userId]);

    return (
        <div className="userSection">
            <div className="userSection__head">
                <div>
                    <span>История</span>
                    <h3>История просмотров товаров</h3>
                    <p>Просмотров: {history.length}. Уникальных позиций: {Number(totalNumberProduct || 0)}.</p>
                </div>
            </div>

            <div className="userProductHistory">
                <div className="userProductHistory__items">
                    {loading ? (
                        <Loader />
                    ) : !history.length ? (
                        <EmptyMessage message={message || "История просмотров пуста."} />
                    ) : (
                        history.map((item) => (
                            <div className="userProductHistory__item" key={`${item._id}-${item.createdAt || ""}`}>
                                <div className="userProductHistory__imgBox">
                                    {item.img ? <img src={generatePublicUrl(item.img)} alt={item.fullName || "Товар"} /> : null}
                                </div>
                                <div className="userProductHistory__fullName">{item.fullName || "Товар"}</div>
                                <div className="userProductHistory__createdAt">
                                    {item.createdAt ? `${item.createdAt.slice(0, 10)} ${item.createdAt.slice(11, 19)}` : "—"}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserHistoryItems;
